/*
 * @Description: 用户数据管理
 * @Autor: WangYuan
 * @Date: 2021-05-19 09:49:33
 * @LastEditors: WangYuan
 * @LastEditTime: 2021-12-15 17:13:13
 */
import {
  setAuthToken,
  getAuthToken,
  setAuthUserInfo,
  getAuthUserInfo,
  clearLoginStorage
} from '@/utils/auth'

const PERMISSIONS_KEY = 'user-permissions'

export default {
  state: {
    token: getAuthToken(),
    userInfo: getAuthUserInfo(),
    userPermissions: JSON.parse(localStorage.getItem(PERMISSIONS_KEY) || 'null')
  },
  getters: {
    token: state => state.token,
    userInfo: state => state.userInfo,
    userPermissions: state => state.userPermissions
  },
  mutations: {
    setToken (state, token) {
      state.token = token
      setAuthToken(token)
    },
    setUserInfo (state, userInfo) {
      state.userInfo = userInfo
      setAuthUserInfo(userInfo)
    },
    setUserPermissions (state, permissions) {
      state.userPermissions = permissions
      localStorage.setItem(PERMISSIONS_KEY, JSON.stringify(permissions))
    },
    logout (state) {
      state.token = null
      state.userInfo = null
      state.userPermissions = null
      state.project = {}
      state.curPage = null
      state.curComponent = null
      state.dragComponent = null
      state.dragStatus = false
      clearLoginStorage()
    }
  },
  actions: {},
  modules: {}
}
